import { FC, PropsWithChildren } from 'react';

export const FormRow: FC<PropsWithChildren> = ({ children }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">{children}</div>
);
